<template>
  <div class="suggested-component" :class="{ bulk: type === 'bulk' }">
    <div class="top-tab">
      <div
        class="tab-item"
        @click="switchTab(index)"
        :class="{ select: index === tabIndex }"
        v-for="(group, index) in groups"
      >
        {{ group.category }}
      </div>
    </div>
    <div class="suggested-list-container">
      <calender-caption
        :type="type"
        :key="tag.id"
        @click="itemClick"
        :model="tag"
        v-for="tag in groups[tabIndex].hashtags"
      ></calender-caption>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "../../../../assets/style/theme";

.suggested-component {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: scroll;
  &.bulk {
    .top-tab {
      padding: 0;
    }
  }
  .top-tab {
    height: 44px;
    line-height: 30px;
    padding: 0 20px;
    overflow-x: auto;
    .tab-item {
      font-size: 13px;
      display: inline;
      margin-right: 15px;
      cursor: pointer;
      white-space: nowrap;
      &.select {
        color: @theme-color;
      }
      :hover,
      :active {
        opacity: 0.7;
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .suggested-list-container {
    flex: 1;
    overflow: auto;
  }
}
</style>

<script>
import groups from "../../../../const/suggest_hashtag";
import calenderCaption from "../../../calender/caption/Index.vue";
import { CURRENT_PUBLISHER_SIMPLE } from "../../../../store/mutation-types";
import { permissionValidate } from "../../../../service/publisher";
import { mapGetters } from "vuex";

export default {
  name: "SuggestComponent",
  components: { calenderCaption },
  props: {
    type: {
      type: String,
      default: "normal",
    },
  },
  computed: {
    ...mapGetters({
      publisher: CURRENT_PUBLISHER_SIMPLE,
    }),
    /**
     * 获取当前登录人权限
     */
    permission() {
      return this.publisher.permissions;
    },
    /**
     * 是否拥有suggest的权限
     * @returns {Boolean}
     */
    suggestPermission() {
      return this.permission.suggested_hashtag;
    },
  },
  data() {
    return {
      groups,
      tabIndex: 0,
    };
  },
  methods: {
    switchTab(index) {
      this.tabIndex = index;
    },
    async itemClick(item) {
      // 如果没有权限则弹出对应升级提示
      if (!this.suggestPermission) {
        await permissionValidate({ type: "full" });
      } else {
        this.$emit("itemClick", item);
      }
    },
  },
  created() {
    this.groups.forEach((g) => {
      g.hashtags.forEach((h) => {
        h.text = h.hashtag;
      });
    });
  },
};
</script>
